/**
 * Deze klasse toont de aanwezige sessions en geeft de mogelijkheid om ze te beheren en een nieuwe aan te maken
 *
 * @history
 * 1 augustus 2022
 * Basis implementatie met tonen en alleen selecteren
 *
 */

import React from "react";
import {SmallPopup} from "../containers/SmallPopup";



export class SessionSelection extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "popup_closed": false,
        }

        this.loadSessionClicked = this.loadSessionClicked.bind(this);
        this.newSessionClicked = this.newSessionClicked.bind(this);
        this.downloadSessionClicked = this.downloadSessionClicked.bind(this);
        this.deleteSessionClicked = this.deleteSessionClicked.bind(this);
    }

    loadSessionClicked(p_session_id)
    {
        window.app.loadSession(p_session_id);
    }

    downloadSessionClicked(p_session_id)
    {
        window.app.downloadLog(p_session_id);
    }

    deleteSessionClicked(p_session_id)
    {
        window.app.deleteSession(p_session_id);
    }

    newSessionClicked()
    {
        window.app.newSession();
    }

    render()
    {
        return (


            <div className={"tool__content__page__wrapper"}>
                <h1>{this.props.page.title}</h1>
                <div className={this.props.page.font_size == "pupil" ? "tool__content__page__content_pupil" : "tool__content__page__content_teacher"} dangerouslySetInnerHTML={{__html: this.props.page.content}}></div>


                <p><a href="javascript:void(0)" className={"button"} onClick={() => this.newSessionClicked()}>Maak een nieuw thema</a></p>
                <p>Kies een eerder aangemaakt thema:</p>
                <div className={"tool__content__session__selection__table"}>
                    {this.props.sessions.map(session =>
                        (
                            <div style={{"border-bottom": "solid 1px #EEE", "padding-bottom": "0.5rem", "width": "100%", "float": "left"}}>
                                {session.title}
                                <div style={{"float": "right", "margin-left": "20px"}}>
                                    <a href="javascript:void(0)" className={"button button_session_selection"} onClick={() => this.loadSessionClicked(session.id)}>Openen</a>
                                    <a href="javascript:void(0)" className={"button button_session_download"} onClick={() => this.downloadSessionClicked(session.id)}>Logboek downloaden</a>
                                    <a href="javascript:void(0)" className={"button button_session_delete"} onClick={() => this.deleteSessionClicked(session.id)}>Verwijderen</a>
                                </div>
                            </div>
                        )
                    )}
                </div>

                {!this.state.popup_closed && (
                    <SmallPopup title={"Letop!"} has_close_btn={true} callback={()=>this.setState({"popup_closed":true})}>
                    <div>
                        <p>In deze app kun je kiezen voor het gebruik van eigen school- en kind foto’s of pictogrammen.<br/>
                            Het gebruik van eigen foto’s  valt onder de AVG regels en verantwoordelijkheid van de school.</p>
                        <p><strong>Let dus op bij het maken van foto’s!</strong><br/>
                            * Foto’s van hoeken maken zonder kinderen<br/>
                            * Of gebruik plaatjes of pictogrammen voor kinderen.</p>
                    </div>
                    </SmallPopup>
                )}

            </div>

        );
    }

}
